import React, { useEffect } from 'react';
import AcceptInvite from '@/pages/invite/AcceptInvite';

interface InviteAcceptWrapperProps {
  routeType: 'path-param' | 'query-param';
}

export function InviteAcceptWrapper({ routeType }: InviteAcceptWrapperProps) {
  useEffect(() => {
    console.log(`🎯 Route matched for invitation: ${routeType}`, {
      pathname: window.location.pathname,
      search: window.location.search,
      href: window.location.href,
      timestamp: new Date().toISOString()
    });
  }, [routeType]);

  return <AcceptInvite />;
}